import { useEffect, useState } from "react";
import images from "../libs/images"

export default function Radio(props) {
    const {
        className = "",
        options = [],
        value,
        setValue,
        border = true
    } = props;

    return <div className={`radio4${border ? "" : " border_none"} ${className ? className : ""}`}>
        {options.map((v, i) => {
            return <div key={"r4-ra-" + i} className="box" onClick={() => {
                if (setValue) setValue(v?.value)
            }}>
                <img
                    className={v?.value === value && "icon-show"}
                    src={v?.value === value ? images.radio_on : images.radio_off} />
                {v.label}
            </div>
        })}
    </div >
}